import {RootState} from './store';

export const selectLastRequestValue = (state: RootState) => state.lastRequest.value;
export const selectDistrictFilterValue = (state: RootState) => state.districtFilter.value;

